<article
  #karte
  class="ki-entwurf-card"
  tabindex="-1"
  data-testid="ki-entwurf-card"
  [class.ki-entwurf-card--uebernommen]="stand() === 'uebernommen'"
  [class.ki-entwurf-card--verworfen]="stand() === 'verworfen'"
>
  <div class="ki-entwurf-card__kopf">
    <app-ki-badge [label]="'ki.entwurfKarte.badge' | translate" />
    @if (bearbeiten()) {
      <input
        #titelEingabe
        type="text"
        class="ki-entwurf-card__titel-eingabe"
        data-testid="ki-entwurf-titel-eingabe"
        [attr.aria-label]="'ki.entwurfKarte.titelLabel' | translate"
        [attr.maxlength]="maxLaenge"
        [value]="titelEntwurf()"
        (input)="titelGeaendert($event)"
        (keydown.enter)="enter($event)"
        (keydown.escape)="escape($event)"
      />
    } @else {
      <span
        #titelText
        class="ki-entwurf-card__titel"
        [attr.aria-label]="titel()"
        [attr.tabindex]="gekuerzt() ? 0 : null"
        [matTooltip]="titel()"
        [matTooltipDisabled]="!gekuerzt()"
      >
        {{ titel() }}
      </span>
    }
    @if (entwurf().art; as art) {
      <span class="ki-entwurf-card__art">{{ 'ki.entwurfKarte.art.' + art | translate }}</span>
    }
    @if (entwurf().prioritaet; as prioritaet) {
      <span class="ki-entwurf-card__prioritaet" [class.ki-entwurf-card__prioritaet--hoch]="prioritaetHoch()">
        {{ 'testCases.priority.' + prioritaet | translate }}
      </span>
    }
  </div>
  <div class="ki-entwurf-card__koerper">
    @if (entwurf().vorbedingung; as vorbedingung) {
      <div class="ki-entwurf-card__vorbedingung">
        <strong>{{ 'ki.entwurfKarte.vorbedingung' | translate }}</strong>
        {{ vorbedingung }}
      </div>
    }
    @for (schritt of entwurf().schritte; track $index) {
      <div class="ki-entwurf-card__schritt">
        <span class="ki-entwurf-card__nr">{{ schritt.nr }}</span>
        <span>{{ schritt.schritt }}</span>
        <span class="ki-entwurf-card__soll">
          <strong>{{ 'ki.entwurfKarte.soll' | translate }}</strong>
          {{ schritt.erwartung }}
        </span>
      </div>
    }
  </div>
  <div class="ki-entwurf-card__fuss">
    @if (stand() === 'uebernommen') {
      <span class="ki-entwurf-card__uebernommen" data-testid="ki-entwurf-uebernommen">
        <mat-icon class="ki-entwurf-card__uebernommen-icon" aria-hidden="true">check</mat-icon>
        <span class="ki-entwurf-card__uebernommen-text">
          {{ 'ki.entwurfKarte.uebernommen' | translate: { anfId: anfId() } }}
        </span>
      </span>
    } @else if (stand() === 'verworfen') {
      <span class="ki-entwurf-card__verworfen">{{ 'ki.entwurfKarte.verworfen' | translate }}</span>
      <button
        type="button"
        class="ki-entwurf-card__rueckgaengig"
        data-testid="ki-entwurf-rueckgaengig"
        (click)="rueckgaengig()"
      >
        {{ 'ki.entwurfKarte.rueckgaengig' | translate }}
      </button>
    } @else {
      @if (fehlerKey(); as textKey) {
        <app-ki-fehler
          class="ki-entwurf-card__fehler"
          [text]="textKey | translate"
          [erneutAnbieten]="!gesperrt()"
          (erneut)="uebernehmen()"
        />
      }
      <button
        mat-flat-button
        type="button"
        class="ki-entwurf-card__primaer"
        data-testid="ki-uebernehmen"
        [disabled]="sendet() || !kannUebernehmen()"
        (click)="uebernehmen()"
      >
        {{ (bearbeiten() ? 'ki.entwurfKarte.speichernUebernehmen' : 'ki.entwurfKarte.uebernehmen') | translate }}
      </button>
      @if (bearbeiten()) {
        <button
          mat-stroked-button
          type="button"
          class="ki-entwurf-card__sekundaer"
          data-testid="ki-bearbeiten-abbrechen"
          [disabled]="sendet()"
          (click)="abbrechen()"
        >
          {{ 'ki.entwurfKarte.abbrechen' | translate }}
        </button>
      } @else {
        <button
          mat-stroked-button
          type="button"
          class="ki-entwurf-card__sekundaer"
          data-testid="ki-bearbeiten-uebernehmen"
          [disabled]="sendet() || gesperrt()"
          (click)="startBearbeiten()"
        >
          {{ 'ki.entwurfKarte.bearbeitenUebernehmen' | translate }}
        </button>
      }
      <button
        type="button"
        class="ki-entwurf-card__verwerfen"
        data-testid="ki-verwerfen"
        [disabled]="sendet()"
        (click)="verwerfen()"
      >
        {{ 'ki.entwurfKarte.verwerfen' | translate }}
      </button>
    }
  </div>
</article>
